import AppDispatcher from '../AppDispatcher';
import Remote from '../Remote';

const QuoteHistorySymbolsStore = {
  _symbols: {},

  getSymbols: function (historyId) {
    let result = [];
    for (let i = 0; i < this._symbols.length; i++) {
      if (this._symbols[i].HistoryId == historyId && this._symbols[i].ParentId === 0 /*&& this._symbols[i].Status !== 2*/) {
        result.push(this._symbols[i]);
      }
    }
    return result;
  },

  get: function (symbolId) {
    for (let i = 0; i < this._symbols.length; i++) {
      if (this._symbols[i].Id === symbolId) {
        return this._symbols[i];
      }
    }
    return null;
  },

  emitChange: function () {
    this.trigger(Constants.ActionTypes.QUOTE_HISTORY_SYMBOLS.UPDATE);
  },

  /**
   * @param {function} callback
   */
  addChangeListener: function (callback) {
    this.bind(Constants.ActionTypes.QUOTE_HISTORY_SYMBOLS.UPDATE, callback);
  },

  removeChangeListener: function (callback) {
    this.unbind(Constants.ActionTypes.QUOTE_HISTORY_SYMBOLS.UPDATE, callback);
  },

  handleDispatcher: function (action) {
    switch (action.actionType) {
      case Constants.ActionTypes.QUOTE_HISTORY_SYMBOLS.UPDATE:
        Remote.quoteHistorySymbolsGet(response => {
          this._symbols = response.Result.HistorySymbols;
          this.emitChange();
        });
        break;
      case Constants.ActionTypes.QUOTE_HISTORY_SYMBOLS.SET:
        this._symbols = action.items;
        this.emitChange();
        break;
    }
  }
};

MicroEvent.mixin(QuoteHistorySymbolsStore);

AppDispatcher.register(QuoteHistorySymbolsStore.handleDispatcher.bind(QuoteHistorySymbolsStore));

export default QuoteHistorySymbolsStore;



// WEBPACK FOOTER //
// ./src/js/Stores/QuoteHistorySymbolsStore.js